export default {
      id: "ic_spor_toto_random-usage",
      viewBox: "0 0 17 16",
      url: "/" + "images/icons.3.109.2.svg#ic_spor_toto_random-usage",
      toString: function () {
        return this.url;
      }
    }